import {faCalendarAlt} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import cn from "classnames";
import {setHours, setMinutes} from 'date-fns';
import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {Controller} from "react-hook-form";

function DateRangePicker({
  dateFormat,
  startDate,
  endDate,
  maxDate,
  control,
  prefixFieldName,
  onChange,
  errors,
  rules,
  showTime = false
}) {
  return (
      <div
        className={cn("form-control form-date-range-picker", {
          "form-date-range-picker--error":
            errors && errors[`${prefixFieldName}`],
        })}
      >
        <Controller
          render={({ field }) => (
            <DatePicker
              {...field}
              selected={startDate}
              onChange={(date) => onChange(date?.valueOf() ?? null, endDate)}
              selectsStart
              showTimeSelect={showTime}
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              timeFormat="HH:mm"
              startDate={startDate}
              endDate={endDate}
              dateFormat={dateFormat}
              maxDate={maxDate}
            />
          )}
          name={`${prefixFieldName}.from`}
          control={control}
          defaultValue={startDate}
          rules={rules?.from ?? {}}
        />
        <span>to</span>
        <Controller
          render={({ field }) => (
            <DatePicker
              {...field}
              selected={endDate}
              onChange={(date) => onChange(startDate, date?.valueOf() ?? null)}
              selectsEnd
              showTimeSelect
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              timeFormat="HH:mm"
              startDate={startDate}
              endDate={endDate}
              minDate={startDate}
              dateFormat={dateFormat}
              maxDate={maxDate}
              injectTimes={[setHours(setMinutes(new Date(), 59), 23)]}
            />
          )}
          name={`${prefixFieldName}.to`}
          control={control}
          defaultValue={endDate}
          rules={rules?.to ?? {}}
        />
        {errors && errors[`${prefixFieldName}`]?.["from"] && (
          <span className="input-error-message">
            {errors[`${prefixFieldName}`]["from"].message}
          </span>
        )}
        {errors && errors[`${prefixFieldName}`]?.["to"] && (
          <span className="input-error-message input-error-message-right">
            {errors[`${prefixFieldName}`]["to"].message}
          </span>
        )}
        <span className="form-group-suffix">
          <FontAwesomeIcon icon={faCalendarAlt} />
        </span>
      </div>
  );
}

export default DateRangePicker;
